import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import ErrorBoundary from '../ErrorBoundary';
import ContentModule from '../ContentModule';
import { RichTextProps } from '../RichText';

import sidekick from '@last-rev/cms-sidekick-util';

import { useAuthContext } from '../AuthProvider';
import { RESELLER_GROUP } from '../AuthGuard';

export interface ArticleBodyProps {
  body?: RichTextProps['body'];
  sidekickLookup?: any;
}

export const ArticleBody = ({ body, sidekickLookup }: ArticleBodyProps) => {
  const [filteredBody, setFilteredBody] = useState<RichTextProps['body'] | undefined>(undefined);
  const { authType, apps } = useAuthContext();
  const isArticlesForReseller = apps?.includes(RESELLER_GROUP);

  useEffect(() => {
    if (authType === 'Okta' && body && isArticlesForReseller) {
      const entries =
        body?.links?.entries?.filter(
          (entry: any) =>
            (entry.__typename !== 'Article' && entry.__typename !== 'Link') ||
            !!entry?.requiredRoles?.includes(RESELLER_GROUP)
        ) ?? [];
      setFilteredBody({ ...body, links: { ...body?.links, entries } });
    } else {
      setFilteredBody(body);
    }
  }, [body, authType, isArticlesForReseller]);

  return (
    <ErrorBoundary>
      {filteredBody ? (
        <Box
          component={ContentModule}
          __typename="Text"
          variant="article"
          body={filteredBody}
          {...sidekick(sidekickLookup?.body)}
          data-testid="ArticleBody"
          sx={{
            '& li:has(> p:empty)': {
              display: 'none'
            }
          }}
        />
      ) : null}
    </ErrorBoundary>
  );
};

export default ArticleBody;
